import { Select } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { InvoicesVariantRequestDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { OnChangeToAllVariants } from 'domains/Catalog/Products/pages/components/Variants/types';
import ApplyValuesToAllVariants from '../../../ApplyValuesToAllVariants';

interface OriginSelectProps {
  value?: string;
  onChange: (data: InvoicesVariantRequestDto) => void;
  readonly onChangeToAllVariants?: OnChangeToAllVariants;
}

function OriginSelect({
  value,
  onChange,
  onChangeToAllVariants,
}: Readonly<OriginSelectProps>) {
  const t = useTranslationCatalog('products.detail.invoiceSettings');
  const data = [
    {
      originId: '',
      originName: t('selectPreview'),
    },
    {
      originId: '0',
      originName: t('nationalOption'),
    },
    {
      originId: '1',
      originName: t('foreignOption'),
    },
    {
      originId: '2',
      originName: t('noMarketForeignOption'),
    },
    {
      originId: '3',
      originName: t('natSuperiorImportOption'),
    },
    {
      originId: '4',
      originName: t('natReturnedProductOption'),
    },
    {
      originId: '5',
      originName: t('natLowerImportOption'),
    },
    {
      originId: '6',
      originName: t('foreignDirectImportOption'),
    },
    {
      originId: '7',
      originName: t('purchasedInDomesticMarket'),
    },
  ];

  const handleSelectChange = ({
    target: { name, value },
  }: React.ChangeEvent<HTMLSelectElement>) => {
    onChange({ [name]: value });
  };

  return (
    <Stack.Item fill>
      <FormField.Select
        id="id-origin"
        label={t('titleOrigin')}
        name="origin"
        onChange={handleSelectChange}
        value={value}
      >
        {data?.map(({ originId, originName }) => (
          <Select.Option
            key={`origin-${originId}`}
            value={originId}
            label={originName}
          />
        ))}
      </FormField.Select>
      {onChangeToAllVariants && (
        <ApplyValuesToAllVariants
          value={value}
          onChange={onChangeToAllVariants('invoiceSettings', '', undefined, {
            origin: value,
          })}
        />
      )}
    </Stack.Item>
  );
}

export default OriginSelect;
